module.exports = __webpack_public_path__ + "static/media/Banner_2.a80bcb79.jpg";